import { render, staticRenderFns } from "./confSettingsBase.vue?vue&type=template&id=1649f49d&scoped=true&lang=pug&"
import script from "./confSettingsBase.vue?vue&type=script&lang=js&"
export * from "./confSettingsBase.vue?vue&type=script&lang=js&"
import style0 from "./confSettingsBase.vue?vue&type=style&index=0&id=1649f49d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1649f49d",
  null
  
)

export default component.exports